export enum SwapTab {
  Swap = 'swap',
  Limit = 'limit',
  Send = 'send',
  Buy = 'buy',
}

export enum LendingTab {
  Borrow = 'borrow',
  Lend = 'lend',
}